import React, { useState, useEffect } from "react";
import { Box, IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import LeaderboardSelectionTabs from "./LeaderboardSelectionTabs";
import fullscreenIcon from "../../../images/icons/icon-fullscreen.svg";
import { LEADERBOARDS } from "../../../_config/LeaderboardConfig";
import { iconButtonOverlaySx } from "../../../styles/cyberTheme";

const DASHBOARD_LEADERBOARDS = LEADERBOARDS.filter((lb) => !lb.onlyInFullLeaderboard);

// Configurable interval in milliseconds
const SWITCH_INTERVAL = 100000;

export default function RankingPanel() {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [currentOrgType, setCurrentOrgType] = useState("secondary");
    const navigate = useNavigate();

    const handleFullScreen = () => {
        const { type, orgType } = DASHBOARD_LEADERBOARDS[currentIndex];
        const leaderboardCode = `${type}-${orgType}`;
        console.log(`Navigating to full screen leaderboard: ${leaderboardCode}`);
        navigate(`/leaderboards/${leaderboardCode}`);
    };

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentIndex((prev) => (prev + 1) % DASHBOARD_LEADERBOARDS.length);
        }, SWITCH_INTERVAL);
        return () => clearInterval(timer);
    }, []);

    const CurrentLeaderboard = DASHBOARD_LEADERBOARDS[currentIndex].component;

    return (
        <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
            {/* Leaderboard content */}
            <Box sx={{ flex: 1, minHeight: 0, position: "relative" }}>
                <CurrentLeaderboard refreshInterval={SWITCH_INTERVAL} orgType={currentOrgType} />
                <IconButton
                    onClick={handleFullScreen}
                    sx={{
                        ...iconButtonOverlaySx,
                        position: "absolute",
                        top: 8,
                        right: 8,
                    }}
                >
                    <img src={fullscreenIcon} alt="Full Screen" width={18} height={18} />
                </IconButton>
            </Box>

            <LeaderboardSelectionTabs
                leaderboards={DASHBOARD_LEADERBOARDS}
                currentIndex={currentIndex}
                onSelect={(index) => {
                    setCurrentIndex(index);
                    setCurrentOrgType(DASHBOARD_LEADERBOARDS[index].orgType);
                }}
            />
        </Box>
    );
}